export default store => next => action => {
    if (action.type === '@@router/LOCATION_CHANGE') {
        action.meta = {
            dialog: 'Show confirm!!!'
        };
    }
    if (!action.meta || !action.meta.dialog) {
        return next(action);
    }

    const changingPayload = (changing) => ({
        type: 'DIALOG_EVENT',
        payload: {
            changing
        }
    });

    if (action.meta.dialog.changing !== undefined) {
        next(changingPayload(action.meta.dialog.changing));

        return next(action);
    }

    if (store.getState().dialog.changing) {
        const promise = new Promise((ok, fail) =>
        {
            next({
                type: 'DIALOG_EVENT',
                payload: {
                    changing: false,
                    show: true,
                    yes: () => {
                        next(action);
                        next(changingPayload(false));
                        ok();
                    },
                    no: () => {
                        next(changingPayload(true));
                        fail()
                    },
                    ...action.meta.dialog,
                }
            });
        });

        return promise;
    } else {
        return new Promise((ok) => ok(next(action)));
    }
};



/** WEBPACK FOOTER **
 ** ./src/modules/layout/actions/DialogMiddleware.js
 **/